function checkEmpty(datas, msgs) {
    for (let i = 0; i < datas.length; i++) {
        if (datas[i] === '' || datas[i] === null) {
            return msgs[i] + '不能为空';
        }
    }
    return '';
}

function isBlank(str) {
    if (str === null || str === '') {
        return true;
    }
    return false;
}

function getFileURL(file) {
    var getUrl = null;
    if (window.createObjectURL !== undefined) {
        getUrl = window.createObjectURL(file);
    } else if (window.URL !== undefined) {
        getUrl = window.URL.createObjectURL(file);
    } else if (window.webkitURL !== undefined) {
        getUrl = window.webkitURL.createObjectURL(file);
    }
    return getUrl;
}

function getUrlParam(search, name) {
    let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    let r = search.substr(1).match(reg);
    if (r != null) return unescape(r[2]);
    return null;
}

function toChinese(str) {
    str += '';
    let s1 = ["零", "一", "二", "三", "四", "五", "六", "七", "八", "九"];
    let s2 = ["十", "百", "千", "万", "十", "百", "千", "亿", "十", "百", "千"];
    let result = '';
    let n = str.length;
    for (let i = 0; i < n; i++) {
        let num = str.charAt(i) - '0';
        if (i !== n - 1 && num !== 0) {
            result += s1[num] + s2[n - 2 - i];
        } else {
            result += s1[num];
        }
    }
    return result;
}

function getTime(time) {
    let hour = parseInt(time / 3600);
    let minute = parseInt(time / 60 % 60);
    let second = parseInt(time % 60);
    let hourStr = hour;
    let minuteStr = minute;
    let secondStr = second;
    if (hour < 10) {
        hourStr = '0' + hour;
    }
    if (minute < 10) {
        minuteStr = '0' + minute;
    }
    if (second < 10) {
        secondStr = '0' + second;
    }
    return hourStr + ':' + minuteStr + ':' + secondStr;
}

export {
    checkEmpty,
    isBlank,
    getFileURL,
    getUrlParam,
    toChinese,
    getTime
}


// WEBPACK FOOTER //
// ./src/utils/commonUtils.js